import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import AddUnit from "../../core/modals/inventory/addunit";
import AddCategoryList from "../../core/modals/inventory/addcategorylist";
import { DatePicker } from "antd";
import { ArrowLeft,ChevronDown,Info,LifeBuoy,PlusCircle, Calendar} from "feather-icons-react/build/IconComponents";
import moment from "moment"; 
import useProductForm  from "../../hooks/useProductForm";


const AddProduct = () => {
  const route = all_routes;

  const store = [
    { value: "Bar", label: "Bar" },
    { value: "Exposition", label: "Exposition" },
    { value: "Cuisine", label: "Cuisine" },
    { value: "Stock général", label: "Stock général" },
  ];

  const {
    productName, setProductName,
    selectedCategory, setSelectedCategory,
    selectedUnit, setSelectedUnit,
    selectedStore, setSelectedStore,
    loading, error, fields,
    handleFieldChange, handleSubmit, categoryData, unityData
  } = useProductForm();

  // Préparer les options de catégorie et d'unité
  const categoryOptions = categoryData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const unitOptions = unityData.map((item) => ({
    value: item.id,
    label: item.name,
  }));


  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Nouveau produit</h4>
              <h6>Créer un nouveau produit</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Retour aux produits
                </Link>
              </div>
            </li>
           
          </ul>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div
                className="accordion-card-one accordion"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />

                          <span>Informations sur le produit</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                    <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Stock</label>
                            <Select
                              classNamePrefix="react-select"
                              options={store}
                              placeholder="Choisissez le stock"
                              value={selectedStore}
                              onChange={setSelectedStore}
                            />
                          </div>
                        </div>
                        
                      
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Nom du produit</label>
                            <input 
                              type="text" 
                              placeholder="Entrer le nom du produit"  
                              value={productName}
                              onChange={(e) => setProductName(e.target.value)} 
                              className="form-control" 
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">catégorie</label>
                              <Link
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#add-category"
                              >
                                <PlusCircle className="plus-down-add" />
                                <span>Nouvelle catégorie</span>
                              </Link>
                            </div>
                            <Select
                              classNamePrefix="react-select"
                              options={categoryOptions}
                              placeholder="Choisir"
                              value={selectedCategory}
                              onChange={setSelectedCategory}
                            />
                          </div>
                        
                          
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">Unité</label>
                              <Link
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#add-units"
                              >
                                <PlusCircle className="plus-down-add" />
                                <span>Nouvelle unité</span>
                              </Link>
                            </div>
                            <Select
                              classNamePrefix="react-select"
                              options={unitOptions}
                              placeholder="Choisir"
                              value={selectedUnit}
                              onChange={setSelectedUnit}
                            />
                          </div>
                        </div>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="accordion-card-one accordion"
                id="accordionExample2"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingTwo">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-controls="collapseTwo"
                    >
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list icon">
                          <h5>
                            <LifeBuoy className="add-info" />
                            <span>Prix &amp; Stocks</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div className="accordion-body">
                  
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="row">
                            <div className="col-lg-2 col-sm-2 col-2 ps-0">
                              <div className="add-icon tab">
                                {/* <button
                                  className="btn btn-filter"
                                  onClick={addField}
                                >
                                  Cliquer ici  <PlusCircle className="feather feather-plus-circle" />
                                </button> */}
                              </div>
                            </div>
                          </div>

                          {fields.map((field, index) => (
                            <div className="tab-pane fade show active" key={index}>
                              <div className="row">
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3 add-product">
                                    <label className="form-label">Type de produit</label>
                                    <input
                                      type="text"
                                      placeholder="Ex: couleur, taille, ..."
                                      className="form-control"
                                      value={field.type}
                                      onChange={(e) => handleFieldChange(index, "type", e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="input-blocks add-product">
                                    <label>Prix d&apos;achat</label>
                                    <input
                                      type="number"
                                      min={0}

                                      className="form-control"
                                      placeholder="Ex:100"
                                      value={field.prixAchat}
                                      onChange={(e) => handleFieldChange(index, "prixAchat", e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="input-blocks add-product">
                                    <label>Prix de vente</label>
                                    <input
                                      type="number"
                                      min={0}

                                      className="form-control"
                                      placeholder="Ex:150"
                                      value={field.prixVente}
                                      onChange={(e) => handleFieldChange(index, "prixVente", e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                {/* Quantité */}
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="input-blocks add-product">
                                    <label>Quantité</label>
                                    <input
                                      type="number"
                                      min={0}
                                      className="form-control"
                                      placeholder="Entrer la quantité"
                                      value={field.quantite}
                                      onChange={(e) => handleFieldChange(index, "quantite", e.target.value)}
                                    />
                                  </div>
                                  
        
                                </div>

                                {/* Quantité d'alerte */}
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="input-blocks add-product">
                                    <label>Quantité d&apos;alerte</label>
                                    <input
                                      type="number"
                                      min={0}
                                      className="form-control"
                                      placeholder="Ex: 10"
                                      value={field.alerteQuantite}
                                      onChange={(e) =>
                                        handleFieldChange(index, "alerteQuantite", e.target.value)
                                      }
                                    />
                                  </div>
                                </div>

                                {/* Date d'expiration */}
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="input-blocks">
                                    <label>Date d&apos;expiration</label>
                                    <div className="input-groupicon calender-input">
                                      <Calendar className="info-img" />
                                      <DatePicker
                                        value={field.expirationDate ? moment(field.expirationDate) : null}
                                        onChange={(date) => handleFieldChange(index, "expirationDate", date)}
                                        format="YYYY-MM-DD" // Le format que vous voulez pour l'affichage
                                        className="form-control"
                                        placeholder="Date d'expiration"
                                      />
                                    </div>
                                  </div>
                                </div>


                              
                              </div>
                            </div>
                          ))}
                        
                        </div>
                       
                  
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             
            </div>
            
          </div>
          
          <div className="col-lg-12">
            {error && <div className="alert alert-danger mt-3">{error}</div>}

            <div className="btn-addproduct mb-4">

              <button type="submit" className="btn btn-success mt-3" disabled={loading}>
                {loading ? "Enregistrement..." : "Ajouter le produit"}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
      <AddUnit />

      <AddCategoryList />

    </div>
  );
};

export default AddProduct;
